import React, { useState, useEffect, useLayoutEffect } from "react";
import Dropdown from "./components/Dropdown";
import Footer from "./components/Footer";
import Navbar from "./components/Navbar";
import AdoptModal from "./components/AdoptModal";
import GlobalStyle from "./globalStyles";
import { Switch, Route, useLocation } from "react-router-dom";
import Home from "./pages";
import TermsAndConditions from "./pages/TermsAndConditions";
import PoliticaDeConfidentialitate from "./pages/PoliticaDeConfidentialitate";
import Rotaract from "./pages/Rotaract";
import BuyTicket from "./pages/BuyTicket";
import ThankYou from "./pages/ThankYou";
import { AdoptModalProvider } from "./context/AdoptModalContext";

import Aos from "aos";
import "aos/dist/aos.css";

function App() {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const toggle = () => {
    setIsOpen(!isOpen);
  };

  useLayoutEffect(() => {
    if (location.hash) {
      const id = location.hash.slice(1);
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 60);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash, location.key]);

  useEffect(() => {
    Aos.init({});
  }, []);

  return (
    <AdoptModalProvider>
      <GlobalStyle />
      <Navbar toggle={toggle} />
      <Dropdown isOpen={isOpen} toggle={toggle} />
      <Switch>
        <Route path="/" exact component={Home} />
        <Route path="/termeni-si-conditii" component={TermsAndConditions} />
        <Route
          path="/politica-de-confidentialitate"
          component={PoliticaDeConfidentialitate}
        />
        <Route path="/rotaract" component={Rotaract} />
        <Route path="/inscrie-te" component={BuyTicket} />
        <Route path="/thank-you" component={ThankYou} />
      </Switch>
      <Footer />
      <AdoptModal />
    </AdoptModalProvider>
  );
}

export default App;
